import React from "react";
import Time from "./Time";
import WeatherUnits from "./WeatherUnits";
import "./Weather.css";

export default function WeatherInfo(props) {
  return (
    <div>
      <h1>{props.data.city}</h1>
      <ul className="current-info">
        <Time date={props.data.date} />
        <li className="text-capitalize">{props.data.description}</li>
      </ul>
      <div className="row">
        <div className="col-6">
          <img src={props.data.iconUrl} alt="icon-image" />
          <WeatherUnits data={props.data.temp} />
        </div>
        <div className="col-6">
          <ul className="current-state">
            <li>
              Humidity:{" "}
              <span className="humidity"> {props.data.humidity}%</span>
            </li>
            <li>
              Wind:{" "}
              <span className="wind"> {Math.round(props.data.wind)}km/h</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
